<svg {...$$restProps} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 17" fill="none">
	<mask
		id="mask0_10301_281"
		style="mask-type:alpha"
		maskUnits="userSpaceOnUse"
		x="0"
		y="0"
		width="16"
		height="17"
	>
		<rect y="0.399902" width="16" height="16" fill="#D9D9D9" />
	</mask>
	<g mask="url(#mask0_10301_281)">
		<path
			d="M8 12.3999C6.89522 12.3999 5.95239 12.0094 5.1715 11.2284C4.3905 10.4475 4 9.50468 4 8.3999C4 7.29512 4.3905 6.35229 5.1715 5.5714C5.95239 4.7904 6.89522 4.3999 8 4.3999C9.10478 4.3999 10.0476 4.7904 10.8285 5.5714C11.6095 6.35229 12 7.29512 12 8.3999C12 9.50468 11.6095 10.4475 10.8285 11.2284C10.0476 12.0094 9.10478 12.3999 8 12.3999ZM8.00333 11.1999C8.77889 11.1999 9.43889 10.9266 9.98333 10.3799C10.5278 9.83324 10.8 9.17212 10.8 8.39657C10.8 7.62101 10.5267 6.96101 9.98 6.41657C9.43333 5.87212 8.77222 5.5999 7.99667 5.5999C7.22111 5.5999 6.56111 5.87324 6.01667 6.4199C5.47222 6.96657 5.2 7.62768 5.2 8.40324C5.2 9.17879 5.47333 9.83879 6.02 10.3832C6.56667 10.9277 7.22778 11.1999 8.00333 11.1999Z"
			fill="currentColor"
		/>
	</g>
</svg>
